import { render, staticRenderFns } from "./UserConfigForm.vue?vue&type=template&id=2b7a9ff6&scoped=true&"
import script from "./UserConfigForm.vue?vue&type=script&lang=js&"
export * from "./UserConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./UserConfigForm.vue?vue&type=style&index=0&id=2b7a9ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a9ff6",
  null
  
)

export default component.exports